export default __webpack_public_path__ + "static/media/TransformersImg.42042ea8.jpg";